import { createSlice } from '@reduxjs/toolkit';
import {
  getAccountsWithLicenseList,
} from './accountsWithLicenseAction';

export const accountsWithLicenseListSlice = createSlice({
  name: 'accountsWithLicenseList',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccountsWithLicenseList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAccountsWithLicenseList.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.data;
      state.error = null;
    });
    builder.addCase(getAccountsWithLicenseList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});
